import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import {MatListModule} from '@angular/material/list';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatTooltipModule} from '@angular/material/tooltip';
import { MatDialogModule  } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';

import { IdiomasComponent } from "./idiomas.component";
import { ModalIdioma } from "./modalIdioma.component";
import { ToolbarComponent } from 'app/layout/components/toolbar/toolbar.component';
import { QuickPanelComponent } from 'app/layout/components/quick-panel/quick-panel.component';

@NgModule({
  declarations: [IdiomasComponent,ModalIdioma],
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatChipsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatListModule,
    TranslateModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatDialogModule,
    MatSelectModule
  ],
  entryComponents: [ModalIdioma,ToolbarComponent,QuickPanelComponent]
})
export class IdiomasModule { }
